export const CUSTOMIZED_OTP_LENGTH = 6;

const CUSTOMIZED_OTP_PATTERN = /^\d{6}$/;

export function roleAllowsCustomizedOtp(role) {
  return role?.all_modules_access === true;
}

export function normalizeCustomizedOtpInput(value) {
  return String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, CUSTOMIZED_OTP_LENGTH);
}

export function validateCustomizedOtp(role, value) {
  if (!roleAllowsCustomizedOtp(role)) return '';

  const otp = String(value ?? '').trim();
  if (!otp || CUSTOMIZED_OTP_PATTERN.test(otp)) return '';

  return 'Customized OTP must contain exactly 6 digits or be left blank.';
}

export function customizedOtpForPayload(role, value) {
  if (!roleAllowsCustomizedOtp(role)) return '';
  return String(value ?? '').trim();
}
